import React from 'react'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

function Contacto() {
  return (
    <div className='color-contenedor-contacto'>
        <div>
            <div>cv</div>
        </div>
        <div className='contenedor-contacto'>
        <div className='contenedor-inputs-total'>
            <h1 className='titulo-contactos'>Comunicate con nosotros</h1>
            </div>
            <div className='contenedor-inputs-total'>
                <Form className='contenedor-input'>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label className='color-tipo'>Nombre</Form.Label>
                    <Form.Control type="email" placeholder="Ingrese nombre" />
                </Form.Group>
                </Form>
                <Form className='contenedor-input'>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label className='color-tipo'>Apellido</Form.Label>
                    <Form.Control type="email" placeholder="Ingrese apellido" />
                </Form.Group>
                </Form>
                <Form className='contenedor-input'>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label className='color-tipo'>Direccion</Form.Label>
                    <Form.Control type="email" placeholder="Ingrese direccion" />
                </Form.Group>
                </Form>
                <Form className='contenedor-input'>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label className='color-tipo'>Telefono</Form.Label>
                    <Form.Control type="email" placeholder="Ingrese telefono" />
                </Form.Group>
                </Form>
                <Button variant="primary" size="lg">
          Enviar
        </Button>{' '}
            </div>  
        </div>
        
    </div>
  )
}

export default Contacto